<template>
  <div>
    <p class="mb-2">
      Tài khoản của bạn bắt buộc xác thực 2 bước nhưng chưa gắn Telegram. Làm
      theo các bước sau (link có hiệu lực 10 phút):
    </p>
    <ol class="mb-3 pl-5" style="line-height: 1.7">
      <li>
        Bấm nút <strong>Mở Telegram</strong> bên dưới, hoặc quét mã QR bằng
        camera điện thoại đã cài Telegram.
      </li>
      <li>
        Trong Telegram, bấm <strong>Start</strong> (hoặc
        <strong>Bắt đầu</strong>) ở cuộc trò chuyện với bot.
      </li>
      <li>Bot sẽ báo đã gắn thành công và gửi mã xác thực 6 số.</li>
      <li>
        Quay lại màn hình này — hệ thống tự chuyển sang ô nhập mã, bạn nhập mã 6
        số vừa nhận.
      </li>
    </ol>
    <div class="d-flex align-center mb-3" style="gap: 16px">
      <QrcodeVue :value="link" :size="120" level="M"></QrcodeVue>
      <div>
        <v-btn
          color="primary"
          class="rounded-lg mb-2"
          depressed
          :href="link"
          target="_blank"
          rel="noopener"
        >
          <v-icon left size="18">mdi-send</v-icon>Mở Telegram
        </v-btn>
        <p class="mb-0 neutral--text" style="font-size: 13px">
          <v-progress-circular
            indeterminate
            size="14"
            width="2"
            class="mr-1"
          ></v-progress-circular>
          Đang chờ bạn bấm Start trong Telegram...
        </p>
      </div>
    </div>
    <p class="mb-0 neutral--text" style="font-size: 13px">
      Chưa cài Telegram? Tải ứng dụng Telegram trên điện thoại hoặc máy tính,
      đăng nhập bằng số điện thoại rồi làm lại bước 1.
    </p>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue"

export default {
  components: { QrcodeVue },
  props: {
    link: {
      type: String,
      required: true,
    },
  },
}
</script>
